import { CurrencyPipe } from "@angular/common";
import { HttpClient } from "@angular/common/http";
import { Component, ElementRef, Input, OnInit, ViewChild } from "@angular/core";
import { Modals, Plugins } from "@capacitor/core";
import {
  AlertController,
  IonDatetime,
  LoadingController,
  ModalController,
  ToastController,
} from "@ionic/angular";
import {
  CalendarModal,
  CalendarModalOptions,
  CalendarResult,
} from "ion2-calendar";
import jsQR from "jsqr";
import * as moment from "moment";
import * as pdfMake from "pdfmake/build/pdfmake";
import * as pdfFonts from "pdfmake/build/vfs_fonts";
import { TDocumentDefinitions } from "pdfmake/interfaces";
import { Guia } from "src/app/models/guias.model";
import { ApiService } from "src/app/services/api.service";
import { GuiasService } from "src/app/services/guias.service";
import { UtilsService } from "src/app/services/utils.service";
import { environment } from "src/environments/environment";
const { Toast } = Plugins;
(<any>pdfMake).vfs = pdfFonts.pdfMake.vfs;

declare var Email;

@Component({
  selector: "app-parceiro-edit-guia",
  templateUrl: "./parceiro-edit-guia.page.html",
  styleUrls: ["./parceiro-edit-guia.page.scss"],
})
export class ParceiroEditGuiaPage implements OnInit {
  @ViewChild("video", { static: false }) video: ElementRef;
  @ViewChild("canvas", { static: false }) canvas: ElementRef;
  @ViewChild("mydt") mydt: IonDatetime;
  @Input() guia: Guia;
  dateFrom: any;
  dateTo: any;
  selectedDate: any;
  today = moment().format("YYYY-MM-DD");
  valorTotal: any;

  canvasElement: any;
  videoElement: any;
  canvasContext: any;
  scanActive = false;
  scanResult = null;
  loading: HTMLIonLoadingElement = null;
  customPickerOptions: any;
  selHora: any;
  dataAtendimento: any = null;
  imgCartao = null;
  userData: any;
  tipoAtendimento: string = null;
  flagInputDataAtendimento: string = "";
  constructor(
    private modalCtrl: ModalController,
    private http: HttpClient,
    private alerta: AlertController,
    private toastCtrl: ToastController,
    private loadingCtrl: LoadingController,
    private currencyPipe: CurrencyPipe,
    private api: ApiService,
    private utils: UtilsService,
    private guiaService: GuiasService
  ) {
    this.userData = this.api.getToken().userData;
  }

  ngOnInit() {
    this.imageToBase64();
  }
  selectTipoAtendiento(event: string) {
    this.tipoAtendimento = event;
  }
  inputDataAtendimento(event) {
    this.flagInputDataAtendimento = event;
  }

  agendar() {
    let confirmaAgendamento: boolean =
      this.utils.converteDataParaFormatoIso(this.guia.dataPreAgendada) ===
      this.utils.converteDataParaFormatoIso(this.dataAtendimento)
        ? true
        : false;

    const updatedGuia = new Guia().deserialize({
      ...this.guia,
      dataAtendimento: this.dataAtendimento,
      agendamento: new Date(),
      tipoAtendimento: this.tipoAtendimento,
      status:
        confirmaAgendamento == true ? "Agendado" : "Aguardando Confirmação",
    });

    this.guiaService.edit(updatedGuia).subscribe(
      async () => {
        if (confirmaAgendamento == true) {
          this.http
            .post(`${environment.sendAgendamento}`, {
              send_to: this.guia.id_paciente,
              dataAgendamento: this.dataAtendimento,
              tipoAtendimento: this.tipoAtendimento,
            })
            .subscribe(
              async () => {
                await Toast.show({
                  text: `Notificação enviada para cliente.`,
                  duration: "long",
                  position: "top",
                });
              },
              (error) => {
                console.error(error);
              }
            );

          await Toast.show({
            text: "Guia Agendada com Sucesso",
            duration: "long",
          });
        } else {
          this.http
            .post(`${environment.sendConfirmaAgendamento}`, {
              send_to: this.guia.id_paciente,
              dataAgendamento: this.dataAtendimento,
              tipoAtendimento: this.tipoAtendimento,
            })
            .subscribe(
              async () => {
                await Toast.show({
                  text: `Notificação enviada para cliente confirmar agendamento.`,
                  duration: "long",
                  position: "top",
                });
              },
              (error) => {
                console.error(error);
              }
            );

          await Toast.show({
            text: "Guia aguardando confirmação de agendamento do cliente",
            duration: "long",
          });
        }
        if (this.guia.origem == "Empresarial")
          this.confirmarPagamentoColaboradorRh();
      },
      async (erro) => {
        await Modals.alert({
          title: "Erro",
          message: `${erro.error.message}`,
        });
      },
      () => {
        if (this.guia.origem != "Empresarial") this.fecharJanela();
      }
    );
  }

  ngAfterViewInit() {
    this.canvasElement = this.canvas.nativeElement;
    this.canvasContext = this.canvasElement.getContext("2d");
    this.videoElement = this.video.nativeElement;
  }

  async validarGuia() {
    const updatedGuia = new Guia().deserialize({
      ...this.guia,
      registrada: true,
      status: "Atendida",
      registro: new Date(),
    });
    if (this.guia.qrCode === this.scanResult) {
      const alert = await this.alerta.create({
        cssClass: "alerta",
        mode: "ios",
        header: "Confirma o registro para atendimento desta guia?",
        buttons: [
          {
            text: "Não",
            role: "nao",
            handler: (blah) => {
              this.fecharJanela();
              this.stopScan();
            },
          },
          {
            text: "Sim",
            cssClass: "alert-sucess",
            handler: () => {
              this.stopScan();
              this.guiaService.edit(updatedGuia).subscribe(
                async () => {
                  await Toast.show({
                    text: "Sucesso",
                    duration: "long",
                  });
                },
                async (erro) => {
                  await Modals.alert({
                    title: "Erro",
                    message: `${erro.error.message}`,
                  });
                },
                () => {
                  this.fecharJanela();
                }
              );
            },
          },
        ],
      });
      await alert.present();
    }
    if (this.guia.qrCode != this.scanResult) {
      const alert = await this.alerta.create({
        mode: "ios",
        header: "Código de autenticação inválido",
        cssClass: "alerta",
        buttons: [
          {
            text: "Fechar",
            role: "nao",
            cssClass: "alert-danger",
            handler: (blah) => {
              this.fecharJanela();
            },
          },
        ],
      });
      await alert.present();
    }
  }

  // Helper functions
  async showQrToast() {
    const toast = await this.toastCtrl.create({
      message: `Open ${this.scanResult}?`,
      position: "top",
      buttons: [
        {
          text: "Open",
          handler: () => {
            window.open(this.scanResult, "_system", "location=yes");
          },
        },
      ],
    });
    toast.present();
  }

  reset() {
    this.scanResult = null;
  }

  stopScan() {
    this.scanActive = false;
    /* Ajuste para camera finalizar totalmente */
    const stream = this.videoElement.srcObject;
    const tracks = stream.getTracks();
    tracks.forEach(function (track) {
      track.stop();
    });

    this.videoElement.srcObject = null;
  }

  async startScan() {
    // Not working on iOS standalone mode!
    const stream = await navigator.mediaDevices.getUserMedia({
      video: { facingMode: "environment" },
    });

    this.videoElement.srcObject = stream;
    // Required for Safari
    this.videoElement.setAttribute("playsinline", true);

    this.loading = await this.loadingCtrl.create({});
    await this.loading.present();

    this.videoElement.play();
    requestAnimationFrame(this.scan.bind(this));
  }

  async scan() {
    if (this.videoElement.readyState === this.videoElement.HAVE_ENOUGH_DATA) {
      if (this.loading) {
        await this.loading.dismiss();
        this.loading = null;
        this.scanActive = true;
      }

      this.canvasElement.height = this.videoElement.videoHeight;
      this.canvasElement.width = this.videoElement.videoWidth;

      this.canvasContext.drawImage(
        this.videoElement,
        0,
        0,
        this.canvasElement.width,
        this.canvasElement.height
      );
      const imageData = this.canvasContext.getImageData(
        0,
        0,
        this.canvasElement.width,
        this.canvasElement.height
      );
      const code = jsQR(imageData.data, imageData.width, imageData.height, {
        inversionAttempts: "dontInvert",
      });

      if (code) {
        this.scanActive = false;
        this.scanResult = code.data;
        this.validarGuia();
        //this.showQrToast();
      } else {
        if (this.scanActive) {
          requestAnimationFrame(this.scan.bind(this));
        }
      }
    } else {
      requestAnimationFrame(this.scan.bind(this));
    }
  }

  async openCalendar() {
    const options: CalendarModalOptions = {
      title: "Escolha a Data",
      color: "primary",
      pickMode: "single",
      from: new Date(),
      to: new Date(0),
      weekdays: ["D", "S", "T", "Q", "Q", "S", "S"],
      defaultScrollTo: new Date(),
      defaultDate: new Date(),
    };

    let myCalendar = await this.modalCtrl.create({
      component: CalendarModal,
      componentProps: { options },
    });

    myCalendar.present();

    const event: any = await myCalendar.onDidDismiss();
    const date: CalendarResult = event.data;
    const updatedGuia = new Guia().deserialize({
      ...this.guia,
      dataAtendimento: this.selectedDate,
    });
    if (date !== null) {
      this.selectedDate = moment(date.dateObj).format("DD/MM/YYYY");
      this.guiaService.edit(updatedGuia).subscribe(
        async () => {
          await Toast.show({
            text: "Sucesso",
            duration: "long",
          });
        },
        async (erro) => {
          await Modals.alert({
            title: "Erro",
            message: `${erro.error.message}`,
          });
        },
        () => {
          this.fecharJanela();
        }
      );
    }
  }

  async confirmarPagamento() {
    console.log("confirma");

    const alert = await this.alerta.create({
      //cssClass: 'alert',
      mode: "ios",
      header: "Escolha e confirme a forma de pagamento?",
      cssClass: "alerta",
      inputs: [
        {
          name: "credito",
          type: "radio",
          label: "Cartão de Crédito",
          value: "Cartão de Crédito",
          handler: () => {
            ("Radio 1 selected");
          },
          checked: true,
        },
        {
          name: "debito",
          type: "radio",
          label: "Cartão de Débito",
          value: "Cartão de Débito",
          handler: () => {
            ("Radio 2 selected");
          },
        },
        {
          name: "pix",
          type: "radio",
          label: "Pix",
          value: "PIX",
          handler: () => {
            ("Radio 3 selected");
          },
        },
        {
          name: "dinheiro",
          type: "radio",
          label: "Dinheiro",
          value: "Dinheiro",
          handler: () => {
            ("Radio 4 selected");
          },
        },
        {
          name: "consignado",
          type: "radio",
          label: "Consignado em Folha",
          value: "Consignado em Folha",
          handler: () => {
            ("Radio 5 selected");
          },
        },
        {
          name: "boleto",
          type: "radio",
          label: "Boleto",
          value: "Boleto",
          handler: () => {
            ("Radio 6 selected");
          },
        },
      ],
      buttons: [
        {
          text: "Cancelar",
          role: "nao",
          cssClass: "alert-danger",
          handler: (blah) => {
            this.fecharJanela();
          },
        },
        {
          text: "Confirmar",
          cssClass: "alert-sucess",
          handler: (data) => {
            const updatedGuia = new Guia().deserialize({
              ...this.guia,
              status: "Pago",
              formaPagamento: data,
              pagamento: new Date(),
            });
            this.guiaService.edit(updatedGuia).subscribe(
              async () => {
                await Toast.show({
                  text: "Sucesso",
                  duration: "long",
                });
                this.enviarGuia(this.guia, data);
              },
              async (erro) => {
                await Modals.alert({
                  title: "Erro",
                  message: `${erro.error.message}`,
                });
              },
              () => {
                this.fecharJanela();
              }
            );
          },
        },
      ],
    });
    await alert.present();
  }
  async confirmarPagamentoColaboradorRh() {
    let radioselect: any;
    const alert = await this.alerta.create({
      //cssClass: 'alert',
      mode: "ios",
      header: `Confirmar pagamento consignado em folha do funcionário ${this.guia.nome}?`,
      cssClass: "alerta",
      buttons: [
        {
          text: "Cancelar",
          role: "nao",
          cssClass: "alert-danger",
          handler: (blah) => {
            this.fecharJanela();
          },
        },
        {
          text: "Confirmar",
          cssClass: "alert-sucess",
          handler: (data) => {
            const updatedGuia = new Guia().deserialize({
              ...this.guia,
              status: "Pago",
              formaPagamento: "Consignado em Folha",
              pagamento: new Date(),
            });
            this.guiaService.edit(updatedGuia).subscribe(
              async () => {
                await Toast.show({
                  text: "Sucesso",
                  duration: "long",
                });
                this.enviarGuia(this.guia, data);
              },
              async (erro) => {
                await Modals.alert({
                  title: "Erro",
                  message: `${erro.error.message}`,
                });
              },
              () => {
                this.fecharJanela();
              }
            );
          },
        },
      ],
    });
    await alert.present();
  }

  enviarGuia(guia, formaPagamento) {
    const proced = [];
    guia["procedimentos"].forEach((element) => {
      proced.push({
        procedimento: element.nomeProced,
        valorFinal: this.currencyPipe.transform(
          element.valorFinal,
          "BRL",
          true
        ),
        calc: element.valorFinal,
      });

      this.valorTotal = proced.reduce((i, proc) => i + proc.calc, 0);
    });
    const docDefinition: TDocumentDefinitions = {
      content: [
        {
          columns: [
            [
              {
                image: this.imgCartao,
                fit: [100, 100],
                alignment: "left",
              },
            ],
            {
              image: guia["empresaLogo"],
              fit: [100, 100],
              alignment: "right",
            },
          ],
        },
        {
          text: "Guia de Encaminhamento",
          style: "header",
          alignment: "center",
        },
        //{ text: new Date().toTimeString(), alignment: 'right' },

        {
          text: [`Nome: ${guia["nome"].substring(0, 40)}`],
          style: "subheader",
          alignment: "left",
        },
        {
          text: [`CPF: ${guia["cpf"]}`],
          style: "subheader",
          alignment: "left",
        },
        {
          text: [`Data de Nascimento: ${guia["dataNascimento"]}`],
          style: "subheader",
          alignment: "left",
        },
        {
          text: [`Celular do Paciente: ${guia["celular"]}`],
          style: "subheader",
          alignment: "left",
        },
        {
          text: [`Clínica: ${guia["empresa"].substring(0, 120)}`],
          style: "subheader",
          alignment: "left",
        },
        {
          text: [`Endereço: ${guia["empresaEndereco"].substring(0, 120)}`],
          style: "subheader",
          alignment: "left",
        },
        {
          text: [`Telefone: ${guia["empresaFone"]}`],
          style: "subheader",
          alignment: "left",
        },
        {
          text: [`Data do Agendamento: ${guia["dataAtendimento"]}hs`],
          style: "subheader",
          alignment: "left",
        },
        {
          text: [`Forma de Pagamento: ${formaPagamento}`],
          style: "subheader",
          alignment: "left",
        },
        this.tabela(proced, ["procedimento", "valorFinal"]),

        {
          columns: [[{ qr: `${guia["qrCode"]}`, fit: 75 }]],
        },
      ],
      styles: {
        header: {
          fontSize: 16,
          bold: true,
          margin: [0, 0, 50, 5],
        },
        subheader: {
          fontSize: 11,
          bold: false,
          margin: [0, 5, 5, 0],
        },
        story: {
          italics: true,
          alignment: "center",
        },
        tabela: {
          margin: [0, 5, 5, 15],
          fontSize: 11,
        },
      },
    };

    var data;
    pdfMake.createPdf(docDefinition).getBase64(function (encodedString) {
      data = encodedString;
      alert(`Guia enviada com Sucesso para o email: ${guia["email"]}`);
      Email.send({
        Host: "smtp.elasticemail.com",
        Username: "cpaixaoneto@gmail.com",
        Password: "CFD74D56E716E83E7049FB4B6EA8485C8569",
        To: `${guia["email"]}`,
        From: "contato@cartaopass.com.br",
        Subject: "Guia de atendimento cartão PASS",
        Body: `Obrigado ${guia["nome"]} por usar dos seus benefícios do cartão PASS!<br/>
      Essa é sua guia de atendimento<br/>`,
        Attachments: [
          {
            name: "Guia de Atendimento PASS.pdf",
            data: data,
          },
        ],
      });
    });
  }

  tabela(data, columns) {
    return {
      layout: {
        fillColor: function (rowIndex) {
          return rowIndex % 2 === 0 ? "#CCCCCC" : null;
        },
      },
      style: "tabela",
      headerRows: 2,
      table: {
        headerRows: 1,
        widths: ["auto", "auto"],
        body: this.buildBody(data, columns),
      },
    };
  }

  buildBody(data, columns) {
    const body = [];

    body.push(["Procedimento", "Valor"]);

    data.forEach((row) => {
      const dataRow = [];

      columns.forEach((column) => {
        dataRow.push(row[column]);
      });

      body.push(dataRow);
    });
    body.push([
      "Total",
      this.currencyPipe.transform(this.valorTotal, "BRL", true),
    ]);

    return body;
  }

  imageToBase64() {
    this.http
      .get("./../../../assets/labotech/logo-cartao-pass-labotech.png", {
        responseType: "blob",
      })
      .subscribe((response) => {
        const reader = new FileReader();

        reader.onloadend = () => {
          this.imgCartao = reader.result;
        };

        reader.readAsDataURL(response);
      });
  }

  fecharJanela() {
    this.modalCtrl.dismiss({
      dissmissed: true,
    });
  }
}
